import { createFileRoute } from "@tanstack/react-router";

import { LombardArticles } from "../components/lombard/LombardArticles";
import { LombardCase } from "../components/lombard/LombardCase";
import { LombardCongress } from "../components/lombard/LombardCongress";
import { LombardHero } from "../components/lombard/LombardHero";
import { LombardPackage } from "../components/lombard/LombardPackage";
import { LombardProjects } from "../components/lombard/LombardProjects";
import { LombardSafety } from "../components/lombard/LombardSafety";
import { LombardScope } from "../components/lombard/LombardScope";
import { LeadForm } from "../components/shared/LeadForm";
import { ServicePageLayout } from "../components/site/ServicePageLayout";
import { crumbTuples } from "../lib/breadcrumbs";
import { routes } from "../lib/nav";
import { breadcrumbJsonLd, buildMeta, serviceJsonLd, SITE_URL } from "../lib/site";

const title = "Разработка и цифровизация ломбарда под ключ | HAY.agency";
const description =
  "Разрабатываем сайты и сервисы для ломбардов, внедряем CRM и аналитику, настраиваем продвижение и работу с сетью филиалов.";

export const Route = createFileRoute("/lombard")({
  head: () => {
    const base = buildMeta({
      title,
      description,
      path: routes.lombard,
      image: `${SITE_URL}/og/services/lombard.webp`,
      imageWidth: 1200,
      imageHeight: 630,
      imageAlt: "Цифровые решения для ломбардов — HAY.agency",
      locale: "ru_RU",
    });

    return {
      ...base,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebPage",
                "@id": `${SITE_URL}${routes.lombard}#webpage`,
                url: `${SITE_URL}${routes.lombard}`,
                name: title,
                description,
                inLanguage: "ru-RU",
                isPartOf: { "@id": `${SITE_URL}/#website` },
                breadcrumb: { "@id": `${SITE_URL}${routes.lombard}#breadcrumbs` },
                mainEntity: { "@id": `${SITE_URL}${routes.lombard}#service` },
              },
              serviceJsonLd({
                name: "Цифровые решения для ломбардов",
                description,
                path: routes.lombard,
                id: `${SITE_URL}${routes.lombard}#service`,
                serviceType: "Разработка и цифровизация ломбарда",
                providerId: `${SITE_URL}/#organization`,
                inGraph: true,
              }),
              breadcrumbJsonLd(crumbTuples(routes.lombard), {
                id: `${SITE_URL}${routes.lombard}#breadcrumbs`,
                inGraph: true,
              }),
            ],
          }),
        },
      ],
    };
  },
  component: Page,
});

function Page() {
  return (
    <ServicePageLayout breadcrumb="Решения для ломбардов" jsonLd={false}>
      <LombardHero />
      <LombardPackage />
      <LombardScope />
      <LombardCongress />
      <LombardCase />
      <LombardProjects />
      <LombardArticles />
      <LombardSafety />
      <LeadForm
        id="lombard-cta"
        title="Обсудить цифровую систему ломбарда"
        lead="Расскажите о задаче, филиалах и текущих системах. Мы уточним вводные и предложим подходящий состав решения."
        submitLabel="Обсудить задачу"
      />
    </ServicePageLayout>
  );
}
